<template>

  <div class="dashboard">

    <div class="navbar">

      <div>
        <img :src="url" />
      </div>

      <ul>
        <li>{{ nomSociete }}</li>
        <li>{{ adresse }} {{ pays }}</li>
      </ul>

      <ul>
        <li>
          <font-awesome-icon icon="fa-solid fa-user" class="fa-user" />
        </li>
        <li>
          <span>{{ nom }} {{ prenom }}</span>
          <span>{{ email }}</span>
        </li>
      </ul>

      <ul>
        <li><button @click="deconnexion">Deconnexion</button></li>
      </ul>

    </div>

    <div class="content" v-if="flagTableFirst == false">

      <div class="top">
        <!-- Espaces -->
        <p class="raison-social">Raison Social :</p>
        <select v-if="flagAdmin && flagEspace" v-model="espace" @change="selectEspace">
          <option v-for="(item, index) in espaces" :key="index" :value="item._id">{{ item.raisonSocial }}</option>
        </select>

        <button class="creer-dossier" v-if="flagHandelDossier" @click="handelDossier">Créer un dossier</button>
        <button class="televerser" v-if="flagHandelDossier" @click="handelFichier">Téléverser fichier(s)</button>
      </div>

      <div class="center">
        <ul>
          <li v-for="(parent, index) in listeParent" :key="index" :title="parent.originalname">
            <!-- Logo folder -->
            <p class="folder" v-if="parent.type == 'Dossier'"><i class="fa fa-folder"></i></p>
            <!-- logo file -->
            <p class="file" v-if="parent.type == 'Fichier'"><i class="fa fa-file"></i></p>
            <!-- Orginal Name -->
            <p>{{ parent.originalname.length > 40 ? parent.originalname.substr(0, 30) : parent.originalname }}</p>
            <p>| {{ parent.nom }} {{ parent.prenom }}</p>
            <P>| {{ `${parent.type} ${checkTypeFile(parent.originalname)}` }} |</P>
            <!-- Date create file -->
            <p>{{ new Date(parent.date).toLocaleDateString() }}</p>
            <!-- Apercu  -->
            <button class="apercu" v-if="parent.type == 'Dossier'" @click="voir(parent._id, index)"><i
                class="fa fa-arrow-right"></i>Aperçu</button>
            <!-- Télécharger -->
            <button class="telecharger" v-if="parent.type == 'Fichier'"
              @click="download(parent.filename, 'parent')"><i
                class="fa fa-download"></i>Télécharger</button>
            <!-- Supprimer -->
            <button class="supprimer" v-if="parent.emailInterlocuteur == email && domain[1] == 'gthconsult.ma'"
              @click="supprimer(parent._id, parent.originalname, 'parent')"><i
                class="fa fa-trash"></i>Supprimer</button>
            <!-- Permission -->
            <button class="key" v-if="flagAdmin && parent.emailInterlocuteur == email" @click="access(parent._id,  parent.partager)"><i
                class="fa fa-key"></i>Permission</button>
            <!-- les access -->
          </li>
        </ul>

      </div>
    </div>

    <DeleteModel v-if="flagDeleteModel" :messageDelete="messageDelete" @validerDeleteModel="validerDeleteModel"
      @closeDeleteModel="closeDeleteModel" />
    <Access v-if="flagAccess" :interlocuteurs="interlocuteurs" :idAccess="idAccess" :interlocuteurPartage="interlocuteurPartage" @validerAccess="validerAccess"
      @closeAccess="closeAccess" />
    <Create v-if="flagCreate" :type="type" @closeConfirmation="closeConfirmation"
      @validerConfirmationDossier="validerConfirmationDossier"
      @validerConfirmationFichier="validerConfirmationFichier" />
      <div v-if="isLoading">
        <p>Chargement : {{ uploadProgress }}%</p>
        <progress :value="uploadProgress" max="100"></progress>
      </div>
    <loading v-model:active="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage" />
    <TableFirst v-if="flagTableFirst == true" :idParent="idParent" :titreParent="titreParent" :email="email"
      @retourParent="retourParent" />

  </div>
</template>

<script>
import Interlocuteur from "@/connection/Interlocuteur";
import Espace from "@/connection/Espace";
import Create from "@/components/models/Transfer/Create.vue";
import Access from "@/components/models/Transfer/Access.vue";
import TableFirst from "@/components/models/Transfer/TableFirst.vue";
import DeleteModel from "@/components/models/DeleteModel.vue";
import { useCookies } from "vue3-cookies";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';



const FILE_TYPE_MAP = {
  // Documents
  pdf: 'Pdf',
  txt: 'Txt',
  docx: 'Word',
  doc: 'Word',
  xls: 'Excel',
  xlsx: 'Excel',
  csv: 'CSV',
  ppt: 'Power point',
  pptx: 'Power point',

  // Images
  jpg: 'Image Jpeg',
  jpeg: 'Image Jpeg',
  png: 'Image PNG',
  gif: 'Image GIF',
  bmp: 'Image BMP',
  webp: 'Image WebP',
  svg: 'Image SVG',

  // Vidéos
  mp4: 'Vidéo MP4',
  avi: 'Vidéo AVI',
  mov: 'Vidéo MOV',
  mkv: 'Vidéo MKV',
  flv: 'Vidéo FLV',

  // Audio
  mp3: 'Audio MP3',
  wav: 'Audio WAV',
  aac: 'Audio AAC',
  flac: 'Audio FLAC',

  // Archives
  zip: 'Archive ZIP',
  rar: 'Archive RAR',
  '7z': 'Archive 7z',
  tar: 'Archive TAR',

  // Code & développement
  html: 'Fichier HTML',
  css: 'Fichier CSS',
  js: 'Fichier JavaScript',
  json: 'Fichier JSON',
  xml: 'Fichier XML',
  php: 'Fichier PHP',
  py: 'Fichier Python',
  java: 'Fichier Java',
  cpp: 'Fichier C++',
  c: 'Fichier C',
  ts: 'Fichier TypeScript'
};

export default {
  data() {
    return {
      flagDeleteModel: false,
      messageDelete: "",
      idDeleteModel: null,
      originalnameDeleteModel: null,
      valueDeleteModel: null,
      isLoading: false,
      uploadProgress: 0,
      adresse: null,
      email: null,
      emailCompany: null,
      nom: null,
      nomSociete: null,
      pays: null,
      prenom: null,
      url: null,
      ville: null,
      flagCreate: false,
      listeParent: [],
      type: null,
      flagTableFirst: false,
      idParent: null,
      titreParent: null,
      flagInterlocuteur: false,
      preInterlocuteurs: [],
      interlocuteurs: [],
      interlocuteur: null,
      flagEspace: false,
      espaces: [],
      espace: null,
      flagHandelDossier: false,
      flagHandelFichier: false,
      flagAccess: false,
      idAccess: null,
      interlocuteurPartage : [],
      flagAdmin: false,
      domain: null
    };
  },

  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },

  components: {
    Loading,
    Create,
    TableFirst,
    Access,
    DeleteModel
  },

  methods: {

    closeDeleteModel() {
      this.flagDeleteModel = false;
    },

    async validerDeleteModel() {
      try {
        const result = await Espace.supprimer(this.idDeleteModel, this.originalnameDeleteModel, this.valueDeleteModel);
        if (result === true) {
          this.listeParent = this.listeParent.filter(el => el._id !== this.idDeleteModel);
          this.flagDeleteModel = false;
          this.messageDelete = "";
          this.idDeleteModel = null;
          this.originalnameDeleteModel = null;
          this.valueDeleteModel = null;
        }
      } catch (error) {
        console.error(error);
      }
    },

    checkTypeFile(value) {
      if (!value.includes('.')) return '';
      const ext = value.split('.').pop().toLowerCase();
      return FILE_TYPE_MAP[ext] || '';
    },

    async selectEspace(event) {
      this.isLoading = true;
      const selectedValue = event.target.value;
      this.interlocuteurs = this.preInterlocuteurs.filter(i => i.clientId === selectedValue && i.email !== this.email);
      this.flagInterlocuteur = true;
      this.listeParent = [];
      this.flagHandelDossier = true;
      this.flagHandelFichier = true;

      const espace = this.espaces.find(el => el._id === selectedValue);
      if (!espace) {
        this.isLoading = false;
        return;
      }
      this.emailCompany = espace.email;

      try {
        const result = await Espace.readParent(this.emailCompany);
        const parents = result.data.listeParent || [];
        this.listeParent = parents.filter(item => item.emailInterlocuteur === this.email || item.partager.includes(this.email)).map(item => ({ ...item, status: false }));
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    supprimer(id, originalname, value) {
      this.messageDelete = "Êtes-vous sûr de vouloir supprimer cet élément ?";
      this.idDeleteModel = id;
      this.originalnameDeleteModel = originalname;
      this.valueDeleteModel = value;
      this.flagDeleteModel = true;
    },

    async download(filename, value) {
        try {
            const response = await Espace.download(filename, value);
            
            if (response?.data?.url) {
                window.open(response.data.url, "_blank");
            } else {
                console.error("Lien de téléchargement introuvable");
            }
        } catch (error) {
            console.error("Erreur téléchargement :", error);
        }
    },


    access(id, interlocuteurPartage) {
      this.idAccess = id;
      this.interlocuteurPartage = interlocuteurPartage;
      this.flagAccess = true;
    },

    async validerAccess(interlocuteurs, idAccess) {
      try {
        const result = await Espace.validerAccess(interlocuteurs, idAccess);
        if (result) {
          const index = this.listeParent.findIndex(el => el._id === idAccess);
          if (index !== -1) {
            this.listeParent[index].partager = [...interlocuteurs];
          }
          this.flagAccess = false;
        }
      } catch (error) {
        console.error(error.message);
      }
    },

    closeAccess() {
      this.flagAccess = false;
    },

    retourParent() {
      this.flagTableFirst = false;
    },

    voir(id, index) {
      this.titreParent = this.listeParent[index]?.originalname || '';
      this.idParent = id;
      this.flagTableFirst = true;
    },

    async delete(id) {
      try {
        const result = await Espace.delete(id);
        if (result.data) {
          this.listeParent = this.listeParent.filter(el => el._id !== id);
        }
      } catch (error) {
        console.error(error.message);
      }
    },

    closeConfirmation() {
      this.type = null;
      this.flagCreate = false;
    },
    

    async validerConfirmationDossier(name) {
      this.type = null;
      this.flagCreate = false;
      this.isLoading = true;

      try {
        const result = await Espace.soumetterDossier(this.emailCompany, name, this.email);
        if (result) {
          this.listeParent.unshift(result.data);
          if (!this.flagAdmin) {
            await this.validerAccess([this.email], result.data._id);
          }
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        this.isLoading = false;
      }
    },

async validerConfirmationFichier(documents) {
        this.type = null;
        this.flagCreate = false;
        this.isLoading = true;
        this.uploadProgress = 0;

  try {
    const start = performance.now(); // Début chrono

    const formData = new FormData();
    formData.append("email", this.emailCompany);
    formData.append("emailInterlocuteur", this.email);

    for (let i = 0; i < documents.length; i++) {
      formData.append(i, documents[i]);
    }

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        this.uploadProgress = percentCompleted;
        console.log("Upload progress:", percentCompleted + "%");
      },
      timeout: 0
    };

    const result = await Espace.soumetterFichier(formData, config); // 👉 nouvelle méthode avec config

    if (result?.data?.length) {
      for (const dataItem of result.data) {
        this.listeParent.unshift(dataItem);
        if (!this.flagAdmin) {
          await this.validerAccess([this.email], dataItem._id);
        }
      }
    }

    const end = performance.now();
    const duration = ((end - start) / 1000).toFixed(2);
    console.log(`Upload terminé en ${duration} secondes`);
  } catch (error) {
    console.error("Erreur d'upload :", error);
  } finally {
    this.isLoading = false;
    this.uploadProgress = 0;
  }
},


    handelDossier() {
      this.type = "dossier";
      this.flagCreate = true;
    },

    handelFichier() {
      this.type = "fichier";
      this.flagCreate = true;
    },

    deconnexion() {
      this.cookies.remove("accessToken");
      this.cookies.remove("refreshToken");
      return this.$router.push("/transfer");
    }
  },

  async mounted() {
    const accessToken = this.cookies.get("accessToken");
    if (!accessToken) {
      this.$router.push("/transfer");
      return;
    }

    try {
      const result = await Interlocuteur.profile(accessToken);

      this.adresse = result.adresse;
      this.email = String(result.email);
      this.nom = result.nom;
      this.prenom = result.prenom;
      this.nomSociete = result.nomSociete;
      this.pays = result.pays;
      this.url = result.url;

      this.domain = this.email.split("@");

      if (this.domain[1] === "gthconsult.ma") {
        this.flagEspace = true;
        this.flagAdmin = true;

        const adminEmails = [
          "tarik.addioui",
          "jamal.ettariqi",
          "service.clients",
          "direction",
          "service.supports",
          "service.qhse",
        ];

        const isAdminEmail = adminEmails.includes(this.domain[0]);

        const espacesResult = await Espace.read(accessToken);

        if (isAdminEmail) {
          this.espaces = espacesResult;
        } else {
          this.espaces = espacesResult.filter(e => String(e.raisonSocial).toLowerCase() === "gthconsult");
        }

        this.preInterlocuteurs = await Interlocuteur.read(accessToken);

      } else {
        this.flagEspace = true;
        this.flagAdmin = false;

        const accessResult = await Espace.readAccess(this.email);
        this.listeParent = accessResult.data.listeParent || [];
        this.emailCompany = accessResult.data.email;
        this.flagHandelDossier = true;
        this.flagHandelFichier = true;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
</script>


<style scoped>
.dashboard {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f4f6f8;
  min-height: 100vh;
  font-family: 'Cairo', 'Segoe UI', sans-serif;
}

/* Navbar */
.navbar {
  background-color: #053075;
  padding: 15px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.navbar div img {
  height: 60px;
  border-radius: 8px;
  object-fit: contain;
}

.navbar ul {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 15px;
  margin: 0;
  padding: 0;
}

.navbar ul li {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.navbar ul:nth-child(3) {
  background-color: #fff;
  border-radius: 10px;
  padding: 10px 15px;
  color: #053075;
  font-weight: bold;
}

.navbar ul:nth-child(3) li span {
  font-size: 0.85rem;
  color: #053075;
}

.fa-user {
  font-size: 28px;
  color: #ffffff;
}

/* Button in navbar */
.navbar ul li button {
  background: linear-gradient(90deg, #e52d27, #b31217);
  padding: 10px 25px;
  color: white;
  border: none;
  border-radius: 25px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.3s, background-position 0.4s ease;
  background-size: 200% auto;
}

.navbar ul li button:hover {
  background-position: right center;
  transform: scale(1.05);
}

/* Content container */
.content {
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

/* Top section */
.content .top {
  background: #ffffff;
  padding: 15px;
  box-shadow: 0 4px 12px rgba(0, 87, 227, 0.1);
  display: flex;
  align-items: center;
  gap: 15px;
  border-radius: 15px;
  flex-wrap: wrap;
}

.raison-social {
  font-weight: bold;
  color: #0057e3;
}

.content .top select {
  padding: 10px 15px;
  border-radius: 25px;
  border: 1px solid #ccc;
  background-color: #f1f1f1;
  font-weight: 600;
  min-width: 200px;
}

/* Buttons top */
.content .top .creer-dossier {
  background-color: #28a745;
  color: white;
}

.content .top .televerser {
  background-color: #fd7e14;
  color: white;
}

.content .top button {
  padding: 8px 20px;
  border: none;
  border-radius: 25px;
  font-size: 0.9rem;
  transition: background 0.3s ease, transform 0.3s;
}

.content .top .creer-dossier:hover {
  background-color: #218838;
  transform: scale(1.05);
}

.content .top .televerser:hover {
  background-color: #e8590c;
  transform: scale(1.05);
}

/* Center content list */
.content .center ul {
  list-style: none;
  margin-top: 20px;
  width: 100%;
  padding: 0;
}

.content .center ul li {
  background-color: #ffffff;
  border: 1px solid #0057e3;
  border-radius: 20px;
  padding: 15px 20px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  box-shadow: 0 4px 8px rgba(0, 87, 227, 0.1);
  transition: transform 0.2s;
}

.content .center ul li:hover {
  transform: translateY(-3px);
}

.content .center ul li p {
  margin: 0;
  font-size: 0.95rem;
  color: #333;
}

.content .center ul li button {
  border: none;
  padding: 6px 15px;
  border-radius: 25px;
  font-size: 0.85rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background 0.3s ease, transform 0.2s;
}

.content .center ul li button:hover {
  transform: scale(1.05);
}

.apercu, .telecharger {
  background-color: #348334;
  color: white;
}

.apercu:hover, .telecharger:hover {
  background-color: #2c6f2c;
}

.key {
  background-color: #ffc107;
  color: #212529;
}

.key:hover {
  background-color: #e0a800;
}

.supprimer {
  background-color: #dc3545;
  color: white;
}

.supprimer:hover {
  background-color: #bd2130;
}

.folder i {
  color: #c35c00;
  font-size: 20px;
}

.file i {
  color: #4459c5;
  font-size: 20px;
}
</style>

